import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';

const useTheme = (): { setTheme: (theme: string) => void; theme: string } => useContext(ThemeContext);

export default useTheme;
